var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{attrs:{"type":"button"},on:{"click":_vm.sendLogout}},[_vm._v("Log ud")])])
}
var staticRenderFns = []

export { render, staticRenderFns }